(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-coll-shop-all"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var owlCarousel = document.querySelector('.featured.owl-carousel');

    if (owlCarousel) {
      $(owlCarousel).owlCarousel({
        items: 4,
        loop: true,
        margin: 30,
        autoplay: false,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        autoHeight: true,
        nav: true, // Enable arrows
        navText: ["<i class='arrow'></i>", "<i class='arrow'></i>"],
        dots: false,
        mouseDrag: true, // Enable mouse drag
        touchDrag: true, // Enable touch drag
        dragEndSpeed: 0, // Set drag end speed to 0 to disable slide animation
        responsive: {
          0: {
            items: 1, // Show 1 item from 0px up to 567px
          },
          568: {
            items: 2, // Show 2 items from 568px up to 767px
          },
          768: {
            items: 3, // Show 3 items from 768px up to 999px
          },
          1000: {
            items: 4, // Show 4 items from 1000px and up
          },
        },
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var owlCarousel = document.querySelector('.featured.owl-carousel');

    if (owlCarousel) {
      $(owlCarousel).owlCarousel({
        items: 4,
        loop: true,
        margin: 30,
        autoplay: false,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        autoHeight: true,
        nav: true, // Enable arrows
        navText: ["<i class='arrow fa fa-chevron-left'></i>", "<i class='arrow fa fa-chevron-right'></i>"],
        dots: false,
        mouseDrag: true, // Enable mouse drag
        touchDrag: true, // Enable touch drag
        dragEndSpeed: 0, // Set drag end speed to 0 to disable slide animation
        responsive: {
          0: {
            items: 1, // Show 1 item from 0px up to 567px
          },
          568: {
            items: 2, // Show 2 items from 568px up to 767px
          },
          768: {
            items: 3, // Show 3 items from 768px up to 999px
          },
          1000: {
            items: 4, // Show 4 items from 1000px and up
          },
        },
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  function updateClassBasedOnWidth() {
    const divElement = document.querySelector('.footer__content-top'); // Replace with your div's class or ID

    if (window.innerWidth <= 749) {      
      // const headings = document.querySelectorAll('.footer__blocks-wrapper .footer-block__heading');
      // headings.forEach(function (heading) {
      //   heading.addEventListener('click', function () {
      //     const currentContent = this.nextElementSibling;
      //     // Close all other open content
      //     headings.forEach(function (otherHeading) {
      //       if (otherHeading !== heading) {
      //         const otherContent = otherHeading.nextElementSibling;
      //         if (otherContent.style.maxHeight) {
      //           otherContent.style.maxHeight = null;
      //         }
      //       }
      //     });

      //     // Toggle the current content
      //     if (currentContent.style.maxHeight) {
      //       // Slide up
      //       currentContent.style.maxHeight = null;
      //     } else {
      //       // Slide down
      //       currentContent.style.maxHeight = currentContent.scrollHeight + 'px';
      //     }
      //   });
      // });

      divElement.classList.add('piyush');
    } else {
      divElement.classList.remove('piyush');
    }
  }

  // Debounce function to limit the rate at which the updateClassBasedOnWidth function is executed
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  // Run on page load
  document.addEventListener('DOMContentLoaded', updateClassBasedOnWidth);

  // Run on window resize with debouncing
  window.addEventListener('resize', debounce(updateClassBasedOnWidth, 100));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  // Header Links On Hover
  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });

  // Countary Selector


  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
